<template>
    <v-container fluid>
        <v-card>
            <v-card-title>
                {{ $t('labels.seafarerContractDaysStatistics') }}
            </v-card-title>
            <v-card-text>
                <v-row dense wrap>
                    <v-col cols="12">
                        <DropdownMultiple
                            v-model="statisticsModal.entities"
                            :ajax="true"
                            :data="'entities'"
                            :label="$t('fields.entities')"
                            @input.native.prevent="reloadMaritimeObjects"
                        ></DropdownMultiple>
                    </v-col>
                    <v-col cols="12">
                        <DropdownMultiple
                            v-model="statisticsModal.maritimeObjects"
                            :ajax="false"
                            :data="maritimeObjectForEntitites"
                            :label="'* ' + $t('fields.maritimeObjects')"
                            :key="componentKey"
                        ></DropdownMultiple>
                    </v-col>
                    <v-col cols="12">
                        <DatePicker
                            v-model="statisticsModal.dateFrom"
                            :date-label="'* ' + $t('fields.from')"
                        ></DatePicker>
                    </v-col>
                    <v-col cols="12">
                        <DatePicker v-model="statisticsModal.dateTo" :date-label="'* ' + $t('fields.to')"></DatePicker>
                    </v-col>
                    <v-col cols="4">
                        <v-btn class="mr-2" :disabled="!canExport" color="primary" @click="exportClick(false)">
                            <v-icon small>fa-file-excel</v-icon>&nbsp;{{ $t('buttons.export') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import DropdownMultiple from './trinkets/DropdownMultiple';
import DatePicker from '@/components/trinkets/DatePicker';

export default {
    name: 'SeafarerContractDaysStatistics',
    components: {DropdownMultiple, DatePicker},
    data: function () {
        return {
            statisticsModal: {
                entities: [],
                maritimeObjects: [],
                dateFrom: null,
                dateTo: null,
            },
            maritimeObjectForEntitites: [],
            componentKey: 1,
            canExport: false,
        };
    },
    methods: {
        exportClick() {
            let dataForSelect = this.statisticsModal;
            this.$APICall('post', 'excel/seafarer-contract-days-statistics', dataForSelect, (data) => {
                window.open(data.link);
            });
        },
        reloadMaritimeObjects() {
            if (this.statisticsModal.entities.length > 0) {
                let selectedEntities = this.statisticsModal.entities;
                this.$APICall('post', 'maritime-objects-for-entities', {selectedEntities}, (data, succes) => {
                    if (succes) {
                        this.maritimeObjectForEntitites = data.maritime_objects;
                        this.componentKey++;
                    } else {
                        this.$alert(this.$t('alerts.basicError'));
                    }
                });
            } else {
                this.loadAllMaritimeObjects();
            }
        },
        loadAllMaritimeObjects() {
            this.$APICall('get', 'select/maritime-objects', {}, (data, success) => {
                if (success) {
                    this.maritimeObjectForEntitites = data;
                    this.componentKey++;
                } else {
                    this.$alert(this.$t('alerts.basicError'));
                }
            });
        },
        saveClick(goBack) {
            let success = true;
            if (this.rank.name == '') {
                success = false;
                this.rankValidation.name = false;
            } else {
                this.rankValidation.name = true;
            }
            if (this.rank.abbreviation == '') {
                success = false;
                this.rankValidation.abbreviation = false;
            } else {
                this.rankValidation.abbreviation = true;
            }

            if (this.rank.rank_category_id == null) {
                success = false;
                this.rankValidation.rank_category_id = false;
            } else {
                this.rankValidation.rank_category_id = true;
            }
            if (success) {
                let vm = this;
                let action = 'post';
                let addition = '';
                if (vm.rank.id != 0) {
                    action = 'put';
                    addition = '/' + vm.rank.id;
                }
                this.$APICall(action, 'ranks' + addition, this.rank, (data, success) => {
                    if (success) {
                        vm.inEditMode = false;
                        if (vm.rank.id == 0) {
                            vm.$notify(vm.$t('alerts.basicAdd'));
                        } else {
                            vm.$notify(vm.$t('alerts.basicUpdate'));
                        }
                        vm.$triggerReload();
                        if (goBack) {
                            vm.backClick();
                        }
                    }
                });
            }
        },
    },

    watch: {
        'statisticsModal.entities': {
            handler: function () {
                this.reloadMaritimeObjects();
            },
            deep: true,
        },
        'statisticsModal': {
            handler: function () {
                let success = true;
                if (
                    this.statisticsModal.maritimeObjects.length < 1 ||
                    this.statisticsModal.dateFrom == null ||
                    this.statisticsModal.dateTo == null ||
                    this.statisticsModal.dateFrom > this.statisticsModal.dateTo
                ) {
                    success = false;
                }
                this.canExport = success;
            },
            deep: true,
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
            return;
        }
        this.loadAllMaritimeObjects();
    },
};
</script>

<style scoped></style>
